import { DTA_SUBMISSIONS_URL } from "@util/constant";

/**
 * Component to render in application submissions tab at How to Nominate page DTA
 */
const SubmissionsSection = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 px-6 py-4 pb-5 font-public-sans"
      data-testid="submissions-section-component"
    >
      <p className="mb-8">
        Download the application form&nbsp;
        <a
          href={DTA_SUBMISSIONS_URL}
          className="text-blue-175 hover:text-gray-850 hover:underline"
        >
          here
        </a>
        .
      </p>
    </div>
  );
};

export default SubmissionsSection;
